import { createTheme } from "@mui/material/styles";

// TypeScript declarations for custom palette
declare module "@mui/material/styles" {
  interface Palette {
    custom: {
      background: {
        light: string;
        card: string;
      };
      border: {
        light: string;
      };
      status: {
        success: string;
        hover: string;
      };
    };
  }
  interface PaletteOptions {
    custom?: {
      background: {
        light: string;
        card: string;
      };
      border: {
        light: string;
      };
      status: {
        success: string;
        hover: string;
      };
    };
  }
}

const theme = createTheme({
  palette: {
    // Custom colors for the application
    custom: {
      // Background colors
      background: {
        light: "#f8f9fa",
        card: "#f5f5f5",
      },
      // Border colors
      border: {
        light: "#e0e0e0",
      },
      // Status colors
      status: {
        success: "#4caf50",
        hover: "#e65100",
      },
    },
  },
  typography: {
    body1: {
      fontSize: "1.15rem",
      fontWeight: 500,
    },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&.Mui-focused": {
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "black",
            },
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          "&.MuiInput-root:after": {
            borderBottomColor: "black",
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: "black",
          "&.MuiInputLabel-root": {
            "&.MuiInputLabel-root": {
              color: "black",
            },
            "&.Mui-focused": {
              color: "black",
            },
          },
        },
      },
    },
  },
});

export default theme;
